/*
  Rad · Fiche Stanley/Stella — comportements (bloc « Le textile derrière votre création »,
  « Complétez votre commande », certifications, typographie).
  Le contenu est rendu en Liquid (sections/rad-fiche-stanley + snippets/rad-ss-bloc) ;
  ce script ne fait qu'ajouter les interactions. Sans lui, tout reste lisible.
*/
(function () {
  'use strict';
  var D = document, W = window;
  var calme = function () { return W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches; };
  var mobile = function () { return W.innerWidth <= 900; };
  var raf = W.requestAnimationFrame ? W.requestAnimationFrame.bind(W) : function (f) { return setTimeout(function () { f(Date.now()); }, 16); };

  /* ---------- défilement vers le bloc Stanley/Stella ---------- */
  var bloc = function () { return D.querySelector('section.ss3 .ss3-c'); };
  var allerBloc = function (decalage, focus) {
    var s = bloc(); if (!s) return;
    W.scrollTo({ top: s.getBoundingClientRect().top + W.scrollY - decalage, behavior: calme() ? 'auto' : 'smooth' });
    if (focus) setTimeout(function () { var t = s.querySelector('.tg button'); if (t) t.focus({ preventScroll: true }); }, calme() ? 0 : 700);
  };
  var liens = function () {
    D.querySelectorAll('.rfx-ss').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); allerBloc(40, false); });
    });
    D.querySelectorAll('.rz-card').forEach(function (b) {
      b.addEventListener('click', function () { allerBloc(90, true); });
    });
  };

  /* ---------- panneaux vidéo + onglets ---------- */
  var lire = function (v, oui) {
    if (!v || v.tagName !== 'VIDEO') return;
    if (oui && !calme()) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
  };
  var panneaux = function (sec) {
    sec.querySelectorAll('.pv').forEach(function (pv) {
      var ps = pv.querySelectorAll('.pv-p'), visible = false;
      var tg = pv.previousElementSibling; if (!(tg && tg.classList.contains('tg'))) tg = null;
      var set = function (p) {
        var cur = +p.dataset.i;
        ps.forEach(function (x) { var o = x === p; x.classList.toggle('on', o); lire(x.querySelector('video'), o && visible); });
        if (tg) tg.querySelectorAll('button').forEach(function (b, j) { b.setAttribute('aria-selected', String(j === cur)); });
      };
      ps.forEach(function (p) {
        p.addEventListener('mouseenter', function () { if (!mobile()) set(p); });
        p.addEventListener('focus', function () { set(p); });
        p.addEventListener('click', function () { set(p); });
      });
      if (tg) tg.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { set(ps[+b.dataset.i]); }); });
      if ('IntersectionObserver' in W) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { visible = e.isIntersecting; lire(pv.querySelector('.pv-p.on video'), visible); });
        }, { threshold: 0.3 }).observe(pv);
      }
    });
  };

  /* ---------- effet « dock » sur les vignettes ---------- */
  var dock = function (sec) {
    sec.querySelectorAll('.pv-th').forEach(function (row) {
      var ims = [].slice.call(row.querySelectorAll('img'));
      ims.forEach(function (m, i) {
        m.addEventListener('mouseenter', function () {
          ims.forEach(function (x, j) { var d = Math.abs(i - j); x.style.transform = d === 0 ? 'scale(1.14) translateY(-5%)' : d === 1 ? 'scale(1.04)' : ''; x.style.zIndex = d === 0 ? 2 : d === 1 ? 1 : ''; });
        });
      });
      row.addEventListener('mouseleave', function () { ims.forEach(function (x) { x.style.transform = ''; x.style.zIndex = ''; }); });
    });
  };

  /* ---------- certifications : ouvrir / fermer le détail ---------- */
  var certPli = function () {
    var L = D.querySelector('.ss3 .l40'), t = L && L.querySelector('.cf-tg'); if (!t) return;
    var maj = function () {
      var o = !L.classList.contains('is-ferme');
      t.setAttribute('aria-expanded', String(o));
      t.innerHTML = '<span>' + (o ? 'Masquer le détail' : 'Voir le détail des certifications') + '</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';
    };
    t.addEventListener('click', function () {
      var ferme = !L.classList.contains('is-ferme');
      L.classList.toggle('is-ferme', ferme); maj();
      if (ferme) { var top = L.getBoundingClientRect().top; if (top < 0) W.scrollTo({ top: top + W.scrollY - 90, behavior: calme() ? 'auto' : 'smooth' }); }
    });
  };

  /* ---------- certifications : défilement lent sur mobile (pause au doigt) ---------- */
  var certDefile = function () {
    var L = D.querySelector('.ss3 .l40'), g = L && L.querySelector('.l3-g'); if (!g || g.__auto) return; g.__auto = 1;
    var orig = [].slice.call(g.querySelectorAll('.l40c'));
    orig.forEach(function (c) {
      var k = c.cloneNode(true); k.classList.add('cf-clone'); k.setAttribute('aria-hidden', 'true');
      k.querySelectorAll('a,button,[tabindex]').forEach(function (e) { e.setAttribute('tabindex', '-1'); });
      g.appendChild(k);
    });
    var hold = 0, acc = 0, last = 0;
    var stop = function () { hold = performance.now() + 3500; };
    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { g.addEventListener(ev, stop, { passive: true }); });
    var largeur = function () { var cl = g.querySelector('.cf-clone'); return cl ? cl.offsetLeft - orig[0].offsetLeft : 0; };
    var tick = function (t) {
      if (!g.isConnected) return;
      if (mobile() && !calme() && t > hold) {
        acc += (last ? t - last : 16) * 0.025;
        if (acc >= 1) { var s = Math.floor(acc); acc -= s; var span = largeur(); g.scrollLeft += s; if (span > 0 && g.scrollLeft >= span) g.scrollLeft -= span; }
      } else if (t <= hold) { var sp = largeur(); if (sp > 0 && g.scrollLeft >= sp) g.scrollLeft -= sp; }
      last = t; raf(tick);
    };
    raf(tick);
  };

  /* ---------- « Complétez votre commande » ---------- */
  var cpl = function () {
    var wr = D.querySelector('.rad-fp__cplw'), li = D.querySelector('.rad-fp__cpll'); if (!wr || !li) return;

    /* bureau : glisser à la souris + barre de progression */
    var items = function () { return [].filter.call(li.children, function (c) { return c.offsetParent !== null; }); };
    var iw = function () { var it = items(); return it.length > 1 ? it[1].getBoundingClientRect().left - it[0].getBoundingClientRect().left : 280; };
    var vis = function () { return Math.max(1, Math.round(li.clientWidth / iw())); };
    var maj = function () {
      var it = items().length, p = li.scrollWidth - li.clientWidth, x = li.scrollLeft;
      var f = Math.min(it, Math.round(x / iw()) + 1), l = Math.min(it, f + vis() - 1);
      wr.querySelectorAll('.cn-ct').forEach(function (e) { e.textContent = it ? f + '–' + l + ' sur ' + it : ''; });
      wr.querySelectorAll('.cn-bar u').forEach(function (u) { var r = li.scrollWidth ? li.clientWidth / li.scrollWidth : 1; var w = Math.max(8, r * 100); u.style.width = w + '%'; u.style.left = (p > 0 ? x / p * (100 - w) : 0) + '%'; });
    };
    var dn = false, sx = 0, sl = 0, mv = 0;
    li.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; dn = true; mv = 0; sx = e.clientX; sl = li.scrollLeft; li.classList.add('cn-drag'); });
    W.addEventListener('pointermove', function (e) { if (!dn) return; mv = Math.abs(e.clientX - sx); li.scrollLeft = sl - (e.clientX - sx); });
    W.addEventListener('pointerup', function () { if (dn) { dn = false; li.classList.remove('cn-drag'); } });
    li.addEventListener('click', function (e) { if (mv > 6) { e.preventDefault(); e.stopPropagation(); mv = 0; } }, true);
    li.addEventListener('scroll', maj, { passive: true });
    W.addEventListener('resize', maj, { passive: true });

    /* mobile : deux rangées qui défilent seules, en sens inverse (pause au doigt) */
    var cpm = wr.querySelector('.cpm');
    if (!cpm) {
      cpm = D.createElement('div'); cpm.className = 'cpm';
      cpm.innerHTML = '<div class="cpm-r" data-d="1"></div><div class="cpm-r" data-d="-1"></div><p class="cpm-h"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 7 3 12l5 5M16 7l5 5-5 5M3 12h18"/></svg>Faites glisser pour voir plus</p>';
      li.after(cpm);
    }
    var rs = cpm.querySelectorAll('.cpm-r');
    var build = function () {
      var its = [].filter.call(li.children, function (c) { return c.offsetParent !== null || getComputedStyle(c).display !== 'none'; });
      rs[0].innerHTML = ''; rs[1].innerHTML = '';
      its.forEach(function (c, i) { var k = c.cloneNode(true); k.removeAttribute('id'); rs[i % 2].appendChild(k); });
      rs[1].scrollLeft = rs[1].scrollWidth;
      cpm.hidden = !its.length;
    };
    rs.forEach(function (r) {
      var hold = 0, acc = 0, last = 0, dir = +r.dataset.d;
      var stop = function () { hold = performance.now() + 3500; };
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { r.addEventListener(ev, stop, { passive: true }); });
      var tick = function (t) {
        if (mobile() && !calme() && t > hold && r.scrollWidth > r.clientWidth) {
          acc += (last ? t - last : 16) * 0.03;
          if (acc >= 1) {
            var s = Math.floor(acc), max = r.scrollWidth - r.clientWidth; acc -= s;
            if (dir > 0) r.scrollLeft = r.scrollLeft >= max - 1 ? 0 : r.scrollLeft + s;
            else r.scrollLeft = r.scrollLeft <= 1 ? max : r.scrollLeft - s;
          }
        }
        last = t; raf(tick);
      };
      raf(tick);
    });

    /* les cartes arrivent après coup (recommandations) et changent avec les filtres */
    var tempo;
    var refaire = function () { clearTimeout(tempo); tempo = setTimeout(function () { build(); maj(); typo(wr); }, 80); };
    new MutationObserver(refaire).observe(li, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'style', 'class'] });
    var f = D.querySelector('.rad-fp__cplf'); if (f) f.addEventListener('click', function () { setTimeout(refaire, 120); });
    refaire();
  };

  /* ---------- typographie : sous-titres sans point final, espaces insécables ---------- */
  var sousTitres = function () {
    D.querySelectorAll('.rad-fp__tete p').forEach(function (p) {
      if (p.children.length) return;
      var t = p.textContent.trim(); if (/[^.]\.$/.test(t) && t.length < 140) p.textContent = t.slice(0, -1);
    });
  };
  var typo = function (root) {
    if (!root || !D.createTreeWalker) return;
    var tw = D.createTreeWalker(root, NodeFilter.SHOW_TEXT, null), n;
    while ((n = tw.nextNode())) {
      var p = n.parentNode; if (!p || /SCRIPT|STYLE|TEXTPATH|TEXTAREA/i.test(p.nodeName)) continue;
      var t = n.nodeValue, u = t.replace(/(\d) (?=[A-Za-zÀ-ÿ])/g, '$1 ').replace(/ ([:;?!»%])/g, ' $1').replace(/« /g, '« ');
      if (u !== t) n.nodeValue = u;
    }
  };

  var init = function () {
    var root = D.querySelector('.rad-fp'); if (!root || root.__ss) return; root.__ss = 1;
    var sec = D.querySelector('section.ss3');
    try { sousTitres(); typo(root); } catch (e) {}
    try { liens(); } catch (e) {}
    if (sec) {
      try { panneaux(sec); } catch (e) {}
      try { dock(sec); } catch (e) {}
      try { certPli(); } catch (e) {}
      try { certDefile(); } catch (e) {}
    }
    try { cpl(); } catch (e) {}
  };
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init); else init();
})();
/* ===== v4 · 26/10/2026 : couleurs en quinconce, bandeau, photo calée, prix qui défile, repliables mobile ===== */
(function () {
  var D = document, W = window;
  var root = D.querySelector('.rad-fp.v14'); if (!root || root.dataset.v4) return;
  root.dataset.v4 = '1';
  var q = function (s) { return root.querySelector(s); };
  var mob = function () { return W.innerWidth <= 900; };
  var reduit = W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inf = q('.rad-fp__info'), sw = q('.rad-fp__sw'), zone = q('.v2-zone');

  /* 1. Pastilles : tri par familles (blancs, gris, noirs, beiges, kakis, jaunes, rouges, violets, bleus, verts) */
  var hsl = function (x) {
    var m = /#?([0-9a-f]{6})/i.exec(x || ''); if (!m) return [0, 0, .5, 0];
    var v = parseInt(m[1], 16), r = (v >> 16) / 255, g = (v >> 8 & 255) / 255, b = (v & 255) / 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, h = 0, d = mx - mn;
    if (d) { h = mx === r ? (g - b) / d + (g < b ? 6 : 0) : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; h *= 60; }
    return [h, 0, l, d];
  };
  var famille = function (c) {
    var h = c[0], l = c[2], k = c[3];
    if (l >= .93 || (l >= .84 && k < .12)) return 0;
    if (l <= .2 && k < .06) return 2;
    if (k < .06) return 1;
    if (h >= 15 && h < 40 && k < .4) return 3;
    if (h >= 40 && h < 75 && k < .4) return l >= .7 ? 3 : 4;
    if (h >= 15 && h < 75) return 5;
    if (h < 15 || h >= 330) return 6;
    if (h >= 260) return 7;
    if (h >= 185) return 8;
    return 9;
  };
  var hexOf = function (b) { var i = b && b.querySelector('i'); var m = i && /#[0-9a-f]{6}/i.exec(i.getAttribute('style') || ''); return m ? m[0] : null; };
  if (sw) {
    [].slice.call(sw.querySelectorAll('button')).map(function (b) { var c = hsl(hexOf(b)); return { b: b, c: c, f: famille(c) }; })
      .sort(function (x, y) { return x.f - y.f || y.c[2] - x.c[2]; })
      .forEach(function (x) { sw.appendChild(x.b); });
  }

  /* 2. Quinconce : grille de demi-cases, lignes alternées n / n-1, dernière ligne centrée */
  var plan = function (N, inner, b, gmin) {
    var nmax = Math.max(2, Math.floor(inner / (b + gmin)));
    if (N <= nmax) return { n: N, rows: [N] };
    var best = null;
    for (var n = nmax; n >= Math.max(3, Math.ceil(nmax * 0.6)); n--) {
      var rows = [], left = N, r = 0;
      while (left > 0) { var s = r % 2 ? n - 1 : n, m = Math.min(s, left); rows.push(m); left -= m; r++; }
      var sl = ((rows.length - 1) % 2 ? n - 1 : n) - rows[rows.length - 1];
      var sc = rows.length * 1000 + sl * 10 + (sl % 2 ? 40 : 0) + (nmax - n) * 2;
      if (!best || sc < best.sc) best = { n: n, rows: rows, sc: sc };
    }
    return best;
  };
  var place = function () {
    if (!sw || !zone) return;
    var m = mob(), b = m ? 30 : 28, c = 22, px = m ? 12 : 18, gmin = m ? 3 : 5, gmax = m ? 14 : 8;
    var items = [].slice.call(sw.querySelectorAll('button')), Wz = zone.offsetWidth; if (!Wz) return;
    var inner = Wz - 2 * px, pl = plan(items.length, inner, b, gmin);
    var pitch = Math.min(inner / pl.n, b + gmax);
    sw.style.setProperty('--b', b + 'px'); sw.style.setProperty('--c', c + 'px');
    sw.style.setProperty('--v4rg', Math.max(3, Math.round(pitch * 0.87 - b)) + 'px');
    sw.style.gridTemplateColumns = 'repeat(' + 2 * pl.n + ',' + (pitch / 2).toFixed(3) + 'px)';
    var i = 0;
    pl.rows.forEach(function (mm, r) {
      var s = r % 2 ? pl.n - 1 : pl.n, off = Math.floor((s - mm) / 2);
      var st0 = (r === pl.rows.length - 1 && mm < s) ? (1 + pl.n - mm) : ((r % 2 ? 2 : 1) + 2 * off);
      for (var j = 0; j < mm; j++, i++) { items[i].style.gridRow = String(r + 1); items[i].style.gridColumn = (st0 + 2 * j) + ' / span 2'; }
    });
    sw.classList.add('v4-ok');
  };
  /* Couleur choisie : teinte la pilule du titre */
  var lum = function (h) { var v = parseInt(h.slice(1), 16); return (0.299 * (v >> 16) + 0.587 * (v >> 8 & 255) + 0.114 * (v & 255)) / 255; };
  var teinte = function () { if (!zone || !sw) return; var h = hexOf(sw.querySelector('button[aria-checked="true"]')) || '#8e8e93'; zone.style.setProperty('--sel', h); zone.style.setProperty('--tick', lum(h) > 0.62 ? '#1d1d1f' : '#fff'); };

  /* 3. Bandeau des couleurs : la colonne ouverte rétrécit pour que tout tienne */
  var bandeau = function () {
    var nu = q('.rad-fp__nu'); if (!nu) return;
    var n = nu.querySelectorAll('.rad-fp__bd').length;
    var on = W.getComputedStyle(nu).flexDirection.indexOf('row') === 0 && n > 18;
    nu.classList.toggle('v4-fit', on); if (!on) return;
    var Wd = nu.clientWidth, g = 4, cw = 19, ow = Wd - (n - 1) * (cw + g);
    if (ow > 368) ow = 368;
    if (ow < 240) { ow = 240; cw = (Wd - ow) / (n - 1) - g; }
    nu.style.setProperty('--v4g', g + 'px'); nu.style.setProperty('--v4o', Math.floor(ow) + 'px');
    nu.style.setProperty('--v4f', (cw < 17 ? 11 : 12) + 'px');
  };

  /* 4. Ordinateur : photo à la hauteur de la colonne (jusqu'au bas du bouton Personnaliser), miniatures entières */
  var film = function () {
    var f = q('.rad-fp__film'), sc = q('.rad-fp__scene'); if (!f || !sc) return;
    if (mob()) { f.classList.remove('v7-film'); return; }
    var cs = W.getComputedStyle(f), pt = parseFloat(cs.paddingTop) || 0, pb = parseFloat(cs.paddingBottom) || 0, gap = parseFloat(cs.rowGap) || 0;
    var H = sc.getBoundingClientRect().height, n = Math.max(1, Math.floor((H + gap) / (76 + gap))), th = (H - (n - 1) * gap) / n;
    f.style.setProperty('--v7fh', (H + pt + pb) + 'px'); f.style.setProperty('--v7th', th.toFixed(2) + 'px'); f.classList.add('v7-film');
  };
  var hFerme = 0;
  var fit = function () {
    var sc = q('.rad-fp__scene'), cta = q('.rad-fp__info .rad-fp__cta--principal'); if (!sc || !cta) return;
    if (mob()) { sc.classList.remove('v6-fit'); film(); return; }
    sc.classList.remove('v6-fit'); var fl = q('.rad-fp__film'); if (fl) fl.classList.remove('v7-film');
    sc.style.setProperty('--v6w', sc.getBoundingClientRect().width + 'px');
    /* Hauteur mesurée comme si « Description » et « Options » étaient fermés : la photo ne bouge pas quand on les ouvre */
    var ouverts = [].slice.call(inf.querySelectorAll('details[open]')), h;
    if (!ouverts.length) { h = hFerme = Math.round(cta.getBoundingClientRect().bottom - sc.getBoundingClientRect().top); }
    else if (hFerme) { h = hFerme; }
    else {
      var ouvert = 0;
      ouverts.forEach(function (dt) { var su = dt.querySelector('summary'); if (su) ouvert += dt.getBoundingClientRect().height - su.getBoundingClientRect().height; });
      h = Math.round(cta.getBoundingClientRect().bottom - sc.getBoundingClientRect().top - ouvert);
    }
    if (h > 200) { sc.style.setProperty('--v6h', h + 'px'); sc.classList.add('v6-fit'); }
    film();
  };

  /* 5. Prix du haut : les chiffres défilent quand il change */
  var tk = { busy: false, last: '' }, pb = q('.rad-fp__prix > b');
  var colonne = function (n) { var s = '<span class="v12-col" style="transform:translateY(-' + n * 10 + '%)">'; for (var i = 0; i < 10; i++) s += '<span>' + i + '</span>'; return s + '</span>'; };
  var ticker = function () {
    if (!pb || tk.busy) return;
    var deja = !!pb.querySelector('.v12-d'), txt = deja ? (pb.getAttribute('aria-label') || '') : pb.textContent;
    if (deja && txt === tk.last) return;
    var vieux = tk.last.replace(/[^0-9]/g, ''), j = 0; tk.last = txt; tk.busy = true;
    pb.classList.add('v12-tk');
    pb.innerHTML = Array.from(txt).map(function (c) {
      if (c < '0' || c > '9') return '<span>' + (c === ' ' || c === ' ' ? '&nbsp;' : c) + '</span>';
      var o = vieux.charAt(j++); return '<span class="v12-d" data-n="' + c + '">' + colonne(o === '' || reduit ? +c : +o) + '</span>';
    }).join('');
    pb.setAttribute('aria-label', txt);
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      pb.querySelectorAll('.v12-d').forEach(function (d) { d.firstChild.style.transform = 'translateY(-' + d.dataset.n * 10 + '%)'; });
      tk.busy = false;
    }); });
  };
  if (pb && W.MutationObserver) new MutationObserver(function () { if (!tk.busy) ticker(); }).observe(pb.parentNode, { childList: true, subtree: true, characterData: true });

  /* 6. Mobile : couleurs et tailles repliables (ouvertes au chargement) */
  var heads = [].slice.call(root.querySelectorAll('[data-v14]'));
  var zoneDe = function (h) { return h.closest('.v2-zone, .v7-tz'); };
  var etat = function (z, oui) {
    z.classList.toggle('v14-ferme', !oui);
    var h = z.querySelector('[data-v14]'); if (h && h.hasAttribute('role')) h.setAttribute('aria-expanded', oui ? 'true' : 'false');
  };
  var roles = function () {
    heads.forEach(function (h) {
      var z = zoneDe(h); if (!z) return;
      if (mob()) { h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0'); h.setAttribute('aria-controls', 'v14-' + h.dataset.v14); h.setAttribute('aria-expanded', z.classList.contains('v14-ferme') ? 'false' : 'true'); }
      else { ['role', 'tabindex', 'aria-controls', 'aria-expanded'].forEach(function (a) { h.removeAttribute(a); }); etat(z, true); }
    });
  };
  heads.forEach(function (h) {
    var bascule = function (e) {
      if (!mob()) return;
      if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
      e.preventDefault(); var z = zoneDe(h); if (z) etat(z, z.classList.contains('v14-ferme'));
    };
    h.addEventListener('click', bascule); h.addEventListener('keydown', bascule);
    h.addEventListener('pointerup', function () { setTimeout(function () { h.blur(); }, 0); });
  });

  /* Démarrage et mises à jour */
  var tout = function () { bandeau(); place(); fit(); };
  roles(); teinte(); tout(); ticker();
  root.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.rad-fp__sw button')) setTimeout(teinte, 0); });
  var rz; W.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { hFerme = 0; roles(); tout(); }, 160); });
  W.addEventListener('load', fit);
  if (inf) inf.addEventListener('toggle', function () { setTimeout(fit, 0); }, true);
  if (W.ResizeObserver && inf) { var t; new ResizeObserver(function () { clearTimeout(t); t = setTimeout(fit, 80); }).observe(inf); }
  if (W.ResizeObserver) { var sc0 = q('.rad-fp__scene'); if (sc0) { var t2; new ResizeObserver(function () { clearTimeout(t2); t2 = setTimeout(film, 60); }).observe(sc0); } }
})();
/* ===== 27/10 - Completez votre commande sur ordinateur : une ligne qui defile seule (pause au survol), aide Faites glisser comme sur mobile ===== */ (function () { var D = document, W = window; var wr = D.querySelector('.rad-fp__cplw'), li = wr && wr.querySelector('.rad-fp__cpll'); if (!li || li.__auto) return; li.__auto = 1; var bb = function () { var s = li.style; if (true) { ['width', 'max-width', 'margin-left', 'padding-left', 'padding-right'].forEach(function (p) { s.removeProperty(p); }); return; } s.removeProperty('margin-left'); s.removeProperty('width'); var cw = D.documentElement.clientWidth, r = wr.getBoundingClientRect(), g = Math.max(0, Math.round(r.left)), d = Math.max(0, Math.round(cw - r.right)); s.setProperty('width', cw + 'px', 'important'); s.setProperty('max-width', 'none', 'important'); s.setProperty('margin-left', -g + 'px', 'important'); s.setProperty('padding-left', g + 'px', 'important'); s.setProperty('padding-right', d + 'px', 'important'); }; bb(); W.addEventListener('resize', bb, { passive: true }); W.addEventListener('load', bb); var px = null; li.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') px = e.clientX; }); W.addEventListener('pointermove', function (e) { if (px !== null && Math.abs(e.clientX - px) > 6) li.classList.add('cn-mv'); }); W.addEventListener('pointerup', function () { px = null; setTimeout(function () { li.classList.remove('cn-mv'); }, 0); }); var st = D.createElement('style'); st.textContent = '@media (min-width:901px){html .rad-fp__cplw .cpm{display:flex!important;justify-content:center}.rad-fp__cplw .cpm-r{display:none!important}.rad-fp__cplw .cpm-h{display:flex;align-items:center;justify-content:center;gap:8px;margin:20px 0 0;font-size:12.5px;color:#86868b}.rad-fp__cplw .cpm-h svg{width:18px;height:18px;fill:none;stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;animation:cpmHd 2.4s ease-in-out infinite}.rad-fp__cplw .cn5{display:none!important}html .rad-fp__cplw .rad-fp__cpll{scroll-snap-type:none!important;scroll-behavior:auto!important}}@keyframes cpmHd{0%,100%{transform:translateX(0)}50%{transform:translateX(5px)}}@media (prefers-reduced-motion:reduce){.rad-fp__cplw .cpm-h svg{animation:none}}html .rad-fp__cplw .cn-drag:not(.cn-mv) *{pointer-events:auto!important}'; D.head.appendChild(st); var calme = function () { return W.matchMedia && W.matchMedia('(prefers-reduced-motion: reduce)').matches; }; var hold = 0, acc = 0, last = 0, dir = 1, dans = false; var stop = function () { hold = performance.now() + 3500; }; li.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') dans = true; }); li.addEventListener('pointerleave', function () { dans = false; stop(); }); ['pointerdown', 'wheel', 'touchstart', 'keydown', 'focusin'].forEach(function (ev) { li.addEventListener(ev, stop, { passive: true }); }); var tick = function (t) { var max = li.scrollWidth - li.clientWidth; if (W.innerWidth > 900 && !calme() && !dans && t > hold && max > 0 && !li.classList.contains('cn-drag')) { acc += (last ? Math.min(t - last, 50) : 16) * 0.03; if (acc >= 1) { var s = Math.floor(acc); acc -= s; if (dir > 0 && li.scrollLeft >= max - 1) { dir = -1; hold = t + 1500; } else if (dir < 0 && li.scrollLeft <= 1) { dir = 1; hold = t + 1500; } else li.scrollLeft += dir * s; } } else acc = 0; last = t; requestAnimationFrame(tick); }; requestAnimationFrame(tick); })(); /* ===== v4 · Description / Options : une seule ouverte à la fois ===== */
(function () {
  var mn = document.querySelector('.rad-fp.v14 .rad-fp__menus'); if (!mn || mn.dataset.v4u) return;
  mn.dataset.v4u = '1';
  mn.addEventListener('toggle', function (e) {
    var t = e.target; if (!t.open || t.tagName !== 'DETAILS') return;
    [].slice.call(mn.querySelectorAll('details[open]')).forEach(function (x) { if (x !== t) x.open = false; });
  }, true);
})();
